import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { isObject } from 'lodash';

@Pipe({
  name: 'translate3',
  pure: true
})
@Injectable()
export class Translate3Pipe implements PipeTransform {

  constructor(
    private translateProvider: TranslateService,
  ) { }

  transform(value: any): any {
    if (isObject(value)) {
      if (this.translateProvider.getDefaultLang()) {
        if (value[this.translateProvider.getDefaultLang()]) {
          return Promise.resolve(value[this.translateProvider.getDefaultLang()]);
        } else {
          return Promise.resolve(value['en'] ? value['en'] : value['es']);
        }
      }
    } else {
      return this.translateProvider.get(value).toPromise();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/translate3.ts